import React, { useState } from 'react';
import {
  TextField,
  Button,
  Box,
  FormControl,
  FormHelperText,
  FormControlLabel,
  Checkbox,
  Typography,
  Stack,
  Link,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import OnboardingContainer from '../Component/OnboardingContainer';
import { ScreenBackV2WithTitle } from '../../Components/ScreenBackV2';
import { validateIsEmailAddress } from '../../Utils';
import { RegisterNow } from '../auth/action';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchToken } from '../../../firebase';
import { PoliciesList } from '../../../utils/settings';
import { encryptPassword } from '../../Utils/Encryption/NodeForgeEncryption';

const UserOnboarding = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const data = location.state?.data || null;
  const [userData, setUserData] = useState({
    phone_number: data?.phone_number || null,
    password: data?.password || null,
    confirm_password: data?.confirm_password || null,
    first_name: null,
    last_name: null,
    email: null,
  });

  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!userData?.first_name || userData?.first_name?.length === 0) {
      newErrors.first_name = 'Please enter your First Name';
    }
    if (userData?.first_name?.length < 3) {
      newErrors.first_name = 'First Name must be at least 3 characters';
    }
    if (userData.email && !validateIsEmailAddress(userData.email)) {
      newErrors.email = 'Invalid Email Address';
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }
    const payload = {
      phone_number: encryptPassword(userData.phone_number),
      password: encryptPassword(userData.password),
      confirm_password: encryptPassword(userData.confirm_password),
      firstname: userData.first_name,
      lastname: userData.last_name,
      email: userData.email,
    };
    const { data, error, message } = await RegisterNow(payload);
    if (error) {
      return toast.error(message);
    } else {
      fetchToken();
      dispatch({
        type: 'RESET_FIRM_ONBOARDING_REDUCER',
      });
      toast.success('User registered successfully');
      localStorage.setItem('token', data.token);
      navigate('/FetchFirmDetail');
    }
  };

  return (
    <OnboardingContainer>
      <ScreenBackV2WithTitle title={'User Onboarding'} />
      <form onSubmit={handleSubmit}>
        <FormControl
          sx={{ width: '80%' }}
          margin='normal'
          error={!!errors.first_name}
        >
          <TextField
            className='darkBackground'
            fullWidth
            id='first_name'
            name='first_name'
            autoComplete='first_name'
            autoFocus
            value={userData.first_name}
            color='secondary'
            onChange={(e) =>
              setUserData({ ...userData, first_name: e.target.value })
            }
            label='First Name'
            required
          />
          {errors?.first_name && (
            <FormHelperText>{errors?.first_name}</FormHelperText>
          )}
        </FormControl>
        <FormControl
          sx={{ width: '80%' }}
          margin='normal'
          error={!!errors.last_name}
        >
          <TextField
            className='darkBackground'
            fullWidth
            id='last_name'
            value={userData.last_name}
            color='secondary'
            onChange={(e) =>
              setUserData({ ...userData, last_name: e.target.value })
            }
            label='Last Name'
          />
          {errors.last_name && (
            <FormHelperText>{errors.last_name}</FormHelperText>
          )}
        </FormControl>
        <FormControl
          sx={{ width: '80%' }}
          margin='normal'
          error={!!errors.email}
        >
          <TextField
            className='darkBackground'
            fullWidth
            id='email'
            value={userData.email}
            color='secondary'
            onChange={(e) =>
              setUserData({ ...userData, email: e.target.value })
            }
            label='Email'
          />
          {errors.email && <FormHelperText>{errors.email}</FormHelperText>}
        </FormControl>

        <Box sx={{ mt: 2, width: '80%' }}>
          <Button
            type='submit'
            variant='contained'
            color='primary'
            fullWidth
          >
            Continue
          </Button>
        </Box>
      </form>
    </OnboardingContainer>
  );
};

export default UserOnboarding;
